import { FC } from "react";
import CardEditButtonComponent from "../../../../../../common/components/card/button/add/card-edit-button.component";
import CardComponent from "../../../../../../common/components/card/card.component";
import FormFieldComponent from "../../../../../../common/components/form/field/form-field.component";
import Column from "../../../../../../common/components/grid/column";
import Row from "../../../../../../common/components/grid/row";
import appTranslationsHelper from "../../../../../../languages/app-translations.helper";
import { useSignUpPassengerContext } from "../../common/context/sign-up-passenger.context";
import SignUpPassengerFormStep from "../../common/types/sign-up-passenger-form-step";
import signUpPassengerSummaryHelper from "../sign-up-passenger-summary.helper";

const SignUpPassengerSummaryUserComponent: FC = () => {
  const translations =
    appTranslationsHelper.getPassengerSignUpTranslations().summary.userData;

  const { userData, setCurrentFormStep } = useSignUpPassengerContext();

  const onEditButtonClick = () => {
    setCurrentFormStep(SignUpPassengerFormStep.userData);
  };

  return (
    <CardComponent
      header={{
        title: translations.title,
        actions: [
          <CardEditButtonComponent
            onClick={onEditButtonClick}
            title={translations.editButtonText}
          />,
        ],
      }}
    >
      <Row>
        <Column md={6} lg={3}>
          <FormFieldComponent
            label={translations.firstNameLabel}
            classNames={{ root: "mt-0" }}
          >
            {userData.firstName}
          </FormFieldComponent>
        </Column>
        <Column md={6} lg={3}>
          <FormFieldComponent
            label={translations.lastNameLabel}
            classNames={{ root: "mt-0" }}
          >
            {userData.lastName}
          </FormFieldComponent>
        </Column>
        <Column md={6} lg={3}>
          <FormFieldComponent
            label={translations.mobileLabel}
            classNames={{ root: "mt-0" }}
          >
            {signUpPassengerSummaryHelper.getMobileString(userData.mobile)}
          </FormFieldComponent>
        </Column>
        <Column md={6} lg={3}>
          <FormFieldComponent
            label={translations.alternativeMobileLabel}
            classNames={{ root: "mt-0" }}
          >
            {signUpPassengerSummaryHelper.getMobileString(
              userData.alternativeMobile
            )}
          </FormFieldComponent>
        </Column>
        <Column>
          <FormFieldComponent
            label={translations.addressesLabel}
            classNames={{ root: "mt-0" }}
          >
            {userData.addresses.map((address) => {
              return (
                <div>
                  {signUpPassengerSummaryHelper.getAddressString(address)}
                </div>
              );
            })}
          </FormFieldComponent>
        </Column>
      </Row>
    </CardComponent>
  );
};

export default SignUpPassengerSummaryUserComponent;
